module.exports = __webpack_public_path__ + "img/authentication.2531d7aa.png";